import { CategoryTree } from '~/constants/categoryTree';

export const getCategoryPath = (slug: string, categoryTree: CategoryTree) => {
  return categoryTree.prefix ? `${categoryTree.prefix}/${slug}` : slug;
};
